import React, { useEffect, useState, lazy } from 'react';
export const CTAButton = ({
  children,
  href = '#precio',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  return <a href={href} className={`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center text-[16px] cta-shadow cta-animated ${variant === 'primary' ? 'bg-familia-cyan text-familia-bg hover:bg-familia-coral/90' : 'border-2 border-familia-cyan text-familia-cyan hover:bg-familia-cyan/10'} ${className}`} data-id="element-207">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 54,
    s: 1
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-familia-cyan w-full ${className}`} data-id="element-208">
      <div className="flex flex-col items-center" data-id="element-209">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-210">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-211">
          horas
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-212">:</div>
      <div className="flex flex-col items-center" data-id="element-213">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-214">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-215">
          minutos
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-216">:</div>
      <div className="flex flex-col items-center" data-id="element-217">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-218">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-219">
          segundos
        </span>
      </div>
    </div>;
};
export const PriceCard = () => {
  const items = ['Módulo 1: Cuaderno Mente Despierta (+150 fichas cognitivas)', 'Módulo 2: Guía Movilidad Sin Miedo (Rutinas y prevención de caídas)', 'Módulo 3: Protocolo Cuidado Experto (Alzheimer, Parkinson, Diabetes)', 'Módulo 4: Bitácora de Control 360 (Registros de salud 2026)', 'Módulo 5: Guía del Cuidador Estrella (Anti-Burnout y organización)', 'Módulo vip +150 ejercicios en casa (3 niveles de adaptación)', 'Bono 1: Cocina Vital Nutrición 60+ (Recetas y menú semanal)', 'Bono 2: Kit de Socialización (Cartas y dinámicas familiares)', 'Bono 3: Checklist Hogar Seguro (142 ítems de auditoría)', 'Letra grande y legible en todo el material', 'Ilustraciones claras en cada actividad', 'Registros completables a mano o digital', 'Bibliografía científica validada 2026', '+240 páginas de contenido premium'];
  return <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-6 sm:p-10 shadow-[0_0_30px_-12px_rgba(242,181,68,0.5)] sm:shadow-[0_0_50px_-12px_rgba(242,181,68,0.4)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-220">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase" data-id="element-221">
        ⭐ SISTEMA COMPLETO 2026
      </div>
      <div className="text-center mt-4 mb-8" data-id="element-222">
        <h3 className="text-2xl font-display font-bold mb-1" data-id="element-223">
          Vitalidad 360™
        </h3>
        <p className="text-familia-gray text-sm uppercase tracking-widest" data-id="element-224">
          Master Kit Adultos Mayores · Sistema Completo
        </p>
      </div>
      <div className="flex items-center gap-4 mb-8 bg-familia-card/60 p-4 rounded-xl border border-white/5" data-id="element-225">
        <img src="https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png" alt="Vitalidad 360 Master Kit" width="96" height="96" loading="lazy" className="w-24 h-24 object-contain" data-id="element-226" />
        <div className="flex flex-col items-start" data-id="element-227">
          <span className="text-familia-red line-through text-lg mb-1" data-id="element-228">
            $60 USD
          </span>
          <span className="text-familia-cyan text-4xl font-bold" data-id="element-229">$18 USD</span>
        </div>
      </div>
      <p className="text-familia-gray text-[11px] leading-relaxed mb-6 text-center" data-id="element-230">
        Precio expresado en Dólares Americanos (USD). Durante el proceso de
        pago, la plataforma convertirá automáticamente el valor a tu moneda
        local según el tipo de cambio de tu banco.
      </p>
      <div className="bg-[#F0F7FF] border border-[#00A1FF] rounded-xl p-4 mb-6 text-left" data-id="element-231">
        <h4 className="text-[#001E3C] font-bold text-sm mb-1 flex items-center gap-2" data-id="element-232">
          ✅ Proceso de compra segura
        </h4>
        <p className="text-[#003A70] text-xs leading-relaxed" data-id="element-233">
          Serás redirigido a una pasarela de pago segura y protegida. Compra
          protegida y garantizada. Si no estás conforme, tienes 7 días para
          pedir la devolución total de tu dinero.
        </p>
      </div>
      <CTAButton href="https://kit-vitalidad-360-adultosmayores.impultienda.ar/checkout" className="w-full text-lg py-5 mb-4" data-id="element-234">
        QUIERO DESCARGARLO YA
      </CTAButton>
      <div className="bg-familia-card/60 border border-white/5 rounded-xl p-4 mb-4 text-left" data-id="element-235">
        <p className="text-familia-gray text-[11px] leading-relaxed" data-id="element-236">
          <span className="text-white font-bold" data-id="element-237">Importante:</span> Ingresa tu
          correo electrónico correctamente para recibir el envío inmediato.
          Contamos con soporte de ayuda personalizado para asistirte en todo
          momento.
        </p>
      </div>
      <div className="mb-6 text-center" data-id="element-238">
        <div className="flex justify-center items-center gap-3 mb-2 opacity-80 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-239">
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-800 border border-gray-200" data-id="element-240">
            VISA
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-red-600 border border-gray-200" data-id="element-241">
            MASTERCARD
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-purple-700 border border-gray-200" data-id="element-242">
            DÉBITO
          </span>
        </div>
        <p className="text-familia-gray text-[10px] leading-tight" data-id="element-243">
          🔒 Pago procesado por Visa, Mastercard y Tarjetas de Débito. <br data-id="element-244" />
          Recibes el acceso en menos de 5 min en tu email.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-4 text-[10px] sm:text-xs text-familia-gray mb-8" data-id="element-245">
        <span data-id="element-246">🔒 Pago seguro</span>
        <span data-id="element-247">⚡ Acceso en 5 min</span>
        <span data-id="element-248">🛡️ Garantía 7 días</span>
      </div>
      <div className="space-y-3 border-t border-white/10 pt-8" data-id="element-249">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-250">
            <span className="text-familia-green text-lg" data-id="element-251">✅</span>
            <span className="text-sm sm:text-base font-medium" data-id="element-252">{item}</span>
          </div>)}
      </div>
      <p className="text-center text-familia-gray text-xs mt-8" data-id="element-253">
        Pago único · Sin suscripciones mensuales · Acceso de por vida
      </p>
    </div>;
};